module.exports = __webpack_public_path__ + "img/super6.73894d16.png";